module.exports = __webpack_public_path__ + "static/media/Sibling Behaviour [STICHED][REDUCED].e33873d2.m4v";